export default {"src":"https://cloudflare.edhrec.com/_next/static/media/mana3.6b68bb0b.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};